<template>
  <Icon size="48">
    <Heart class="heart"/>
  </Icon>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { Heart } from '@vicons/ionicons5'
import { Icon } from '@vicons/utils'
export default defineComponent({
  name: 'HeartComponent',
  components: {
    Icon,
    Heart
  },
  setup() {
    const isHeartShown = ref(true)

    setInterval(() => {
      isHeartShown.value = !isHeartShown.value
    }, 500)

    return { isHeartShown }
  },
})
</script>

<style>
.heart {
  color: #f44336;
  animation: beat 1.5s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
  display: inline-block;
}

@keyframes beat {
  0% {
    transform: scale(1);
  }
  14% {
    transform: scale(1.3);
  }
  28% {
    transform: scale(1);
  }
  42% {
    transform: scale(1.3);
  }
  70% {
    transform: scale(1);
  }
}
</style>